export enum ApiStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  LOADING = 'loading',
  INFO = 'info',
  WARNING = 'warning',
}
